var We = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function be(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var le = { exports: {} };
/*!
  * Stickyfill – `position: sticky` polyfill
  * v. 2.1.0 | https://github.com/wilddeer/stickyfill
  * MIT License
  */
(function(o) {
  (function(e, t) {
    var r = /* @__PURE__ */ function() {
      function d(l, u) {
        for (var v = 0; v < u.length; v++) {
          var h = u[v];
          h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
        }
      }
      return function(l, u, v) {
        return u && d(l.prototype, u), v && d(l, v), l;
      };
    }();
    function s(d, l) {
      if (!(d instanceof l))
        throw new TypeError("Cannot call a class as a function");
    }
    var c = !1, a = typeof e < "u";
    !a || !e.getComputedStyle ? c = !0 : function() {
      var d = t.createElement("div");
      ["", "-webkit-", "-moz-", "-ms-"].some(function(l) {
        try {
          d.style.position = l + "sticky";
        } catch {
        }
        return d.style.position != "";
      }) && (c = !0);
    }();
    var y = !1, g = typeof ShadowRoot < "u", m = {
      top: null,
      left: null
    }, p = [];
    function E(d, l) {
      for (var u in l)
        l.hasOwnProperty(u) && (d[u] = l[u]);
    }
    function R(d) {
      return parseFloat(d) || 0;
    }
    function L(d) {
      for (var l = 0; d; )
        l += d.offsetTop, d = d.offsetParent;
      return l;
    }
    var A = function() {
      function d(l) {
        if (s(this, d), !(l instanceof HTMLElement))
          throw new Error("First argument must be HTMLElement");
        if (p.some(function(u) {
          return u._node === l;
        }))
          throw new Error("Stickyfill is already applied to this node");
        this._node = l, this._stickyMode = null, this._active = !1, p.push(this), this.refresh();
      }
      return r(d, [{
        key: "refresh",
        value: function() {
          if (!(c || this._removed)) {
            this._active && this._deactivate();
            var u = this._node, v = getComputedStyle(u), h = {
              position: v.position,
              top: v.top,
              display: v.display,
              marginTop: v.marginTop,
              marginBottom: v.marginBottom,
              marginLeft: v.marginLeft,
              marginRight: v.marginRight,
              cssFloat: v.cssFloat
            };
            if (!(isNaN(parseFloat(h.top)) || h.display == "table-cell" || h.display == "none")) {
              this._active = !0;
              var O = u.style.position;
              (v.position == "sticky" || v.position == "-webkit-sticky") && (u.style.position = "static");
              var C = u.parentNode, P = g && C instanceof ShadowRoot ? C.host : C, F = u.getBoundingClientRect(), D = P.getBoundingClientRect(), b = getComputedStyle(P);
              this._parent = {
                node: P,
                styles: {
                  position: P.style.position
                },
                offsetHeight: P.offsetHeight
              }, this._offsetToWindow = {
                left: F.left,
                right: t.documentElement.clientWidth - F.right
              }, this._offsetToParent = {
                top: F.top - D.top - R(b.borderTopWidth),
                left: F.left - D.left - R(b.borderLeftWidth),
                right: -F.right + D.right - R(b.borderRightWidth)
              }, this._styles = {
                position: O,
                top: u.style.top,
                bottom: u.style.bottom,
                left: u.style.left,
                right: u.style.right,
                width: u.style.width,
                marginTop: u.style.marginTop,
                marginLeft: u.style.marginLeft,
                marginRight: u.style.marginRight
              };
              var n = R(h.top);
              this._limits = {
                start: F.top + e.pageYOffset - n,
                end: D.top + e.pageYOffset + P.offsetHeight - R(b.borderBottomWidth) - u.offsetHeight - n - R(h.marginBottom)
              };
              var i = b.position;
              i != "absolute" && i != "relative" && (P.style.position = "relative"), this._recalcPosition();
              var f = this._clone = {};
              f.node = t.createElement("div"), E(f.node.style, {
                width: F.right - F.left + "px",
                height: F.bottom - F.top + "px",
                marginTop: h.marginTop,
                marginBottom: h.marginBottom,
                marginLeft: h.marginLeft,
                marginRight: h.marginRight,
                cssFloat: h.cssFloat,
                padding: 0,
                border: 0,
                borderSpacing: 0,
                fontSize: "1em",
                position: "static"
              }), C.insertBefore(f.node, u), f.docOffsetTop = L(f.node);
            }
          }
        }
      }, {
        key: "_recalcPosition",
        value: function() {
          if (!(!this._active || this._removed)) {
            var u = m.top <= this._limits.start ? "start" : m.top >= this._limits.end ? "end" : "middle";
            if (this._stickyMode != u) {
              switch (u) {
                case "start":
                  E(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: this._offsetToParent.top + "px",
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;
                case "middle":
                  E(this._node.style, {
                    position: "fixed",
                    left: this._offsetToWindow.left + "px",
                    right: this._offsetToWindow.right + "px",
                    top: this._styles.top,
                    bottom: "auto",
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0,
                    marginTop: 0
                  });
                  break;
                case "end":
                  E(this._node.style, {
                    position: "absolute",
                    left: this._offsetToParent.left + "px",
                    right: this._offsetToParent.right + "px",
                    top: "auto",
                    bottom: 0,
                    width: "auto",
                    marginLeft: 0,
                    marginRight: 0
                  });
                  break;
              }
              this._stickyMode = u;
            }
          }
        }
      }, {
        key: "_fastCheck",
        value: function() {
          !this._active || this._removed || (Math.abs(L(this._clone.node) - this._clone.docOffsetTop) > 1 || Math.abs(this._parent.node.offsetHeight - this._parent.offsetHeight) > 1) && this.refresh();
        }
      }, {
        key: "_deactivate",
        value: function() {
          var u = this;
          !this._active || this._removed || (this._clone.node.parentNode.removeChild(this._clone.node), delete this._clone, E(this._node.style, this._styles), delete this._styles, p.some(function(v) {
            return v !== u && v._parent && v._parent.node === u._parent.node;
          }) || E(this._parent.node.style, this._parent.styles), delete this._parent, this._stickyMode = null, this._active = !1, delete this._offsetToWindow, delete this._offsetToParent, delete this._limits);
        }
      }, {
        key: "remove",
        value: function() {
          var u = this;
          this._deactivate(), p.some(function(v, h) {
            if (v._node === u._node)
              return p.splice(h, 1), !0;
          }), this._removed = !0;
        }
      }]), d;
    }(), I = {
      stickies: p,
      Sticky: A,
      forceSticky: function() {
        c = !1, H(), this.refreshAll();
      },
      addOne: function(l) {
        if (!(l instanceof HTMLElement))
          if (l.length && l[0])
            l = l[0];
          else
            return;
        for (var u = 0; u < p.length; u++)
          if (p[u]._node === l)
            return p[u];
        return new A(l);
      },
      add: function(l) {
        if (l instanceof HTMLElement && (l = [l]), !!l.length) {
          for (var u = [], v = function(P) {
            var F = l[P];
            if (!(F instanceof HTMLElement))
              return u.push(void 0), "continue";
            if (p.some(function(D) {
              if (D._node === F)
                return u.push(D), !0;
            }))
              return "continue";
            u.push(new A(F));
          }, h = 0; h < l.length; h++)
            var O = v(h);
          return u;
        }
      },
      refreshAll: function() {
        p.forEach(function(l) {
          return l.refresh();
        });
      },
      removeOne: function(l) {
        if (!(l instanceof HTMLElement))
          if (l.length && l[0])
            l = l[0];
          else
            return;
        p.some(function(u) {
          if (u._node === l)
            return u.remove(), !0;
        });
      },
      remove: function(l) {
        if (l instanceof HTMLElement && (l = [l]), !!l.length)
          for (var u = function(O) {
            var C = l[O];
            p.some(function(P) {
              if (P._node === C)
                return P.remove(), !0;
            });
          }, v = 0; v < l.length; v++)
            u(v);
      },
      removeAll: function() {
        for (; p.length; )
          p[0].remove();
      }
    };
    function H() {
      if (y)
        return;
      y = !0;
      function d() {
        e.pageXOffset != m.left ? (m.top = e.pageYOffset, m.left = e.pageXOffset, I.refreshAll()) : e.pageYOffset != m.top && (m.top = e.pageYOffset, m.left = e.pageXOffset, p.forEach(function(C) {
          return C._recalcPosition();
        }));
      }
      d(), e.addEventListener("scroll", d), e.addEventListener("resize", I.refreshAll), e.addEventListener("orientationchange", I.refreshAll);
      var l = void 0;
      function u() {
        l = setInterval(function() {
          p.forEach(function(C) {
            return C._fastCheck();
          });
        }, 500);
      }
      function v() {
        clearInterval(l);
      }
      var h = void 0, O = void 0;
      "hidden" in t ? (h = "hidden", O = "visibilitychange") : "webkitHidden" in t && (h = "webkitHidden", O = "webkitvisibilitychange"), O ? (t[h] || u(), t.addEventListener(O, function() {
        t[h] ? v() : u();
      })) : u();
    }
    c || H(), o.exports ? o.exports = I : a && (e.Stickyfill = I);
  })(window, document);
})(le);
var pe = le.exports;
const qe = /* @__PURE__ */ be(pe), Ge = (o, e = document) => [].slice.call(e.querySelectorAll(o)), Ue = (o, e = document) => e.querySelector(o);
class Ye {
  /**
   * Constructs a new EventManager.
   */
  constructor() {
    this.events = /* @__PURE__ */ new Map();
  }
  /**
   * Register a callback for a specific event.
   * @param {string} eventName - The name of the event.
   * @param {Function} callback - The callback function to be executed when the event is triggered.
   */
  on(e, t) {
    this.events.has(e) || this.events.set(e, []), this.events.get(e).push(t);
  }
  /**
   * Trigger an event, executing all registered callbacks for that event.
   * @param {string} eventName - The name of the event to trigger.
   * @param {any} eventData - Additional data to pass to the callbacks.
   */
  trigger(e, t) {
    const r = this.events.get(e);
    r && r.forEach((s) => {
      s(t);
    });
  }
  /**
   * Retrieve the most recently registered callback for a specific event.
   * @param {string} eventName - The name of the event.
   * @returns {Function|null} - The most recently registered callback, or null if none is registered.
   */
  getCallback(e) {
    return this.events.get(e) || [];
  }
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var ue = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], V = /* @__PURE__ */ ue.join(","), fe = typeof Element > "u", K = fe ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, z = !fe && Element.prototype.getRootNode ? function(o) {
  var e;
  return o == null || (e = o.getRootNode) === null || e === void 0 ? void 0 : e.call(o);
} : function(o) {
  return o == null ? void 0 : o.ownerDocument;
}, X = function o(e, t) {
  var r;
  t === void 0 && (t = !0);
  var s = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), c = s === "" || s === "true", a = c || t && e && o(e.parentNode);
  return a;
}, ge = function(e) {
  var t, r = e == null || (t = e.getAttribute) === null || t === void 0 ? void 0 : t.call(e, "contenteditable");
  return r === "" || r === "true";
}, ce = function(e, t, r) {
  if (X(e))
    return [];
  var s = Array.prototype.slice.apply(e.querySelectorAll(V));
  return t && K.call(e, V) && s.unshift(e), s = s.filter(r), s;
}, de = function o(e, t, r) {
  for (var s = [], c = Array.from(e); c.length; ) {
    var a = c.shift();
    if (!X(a, !1))
      if (a.tagName === "SLOT") {
        var y = a.assignedElements(), g = y.length ? y : a.children, m = o(g, !0, r);
        r.flatten ? s.push.apply(s, m) : s.push({
          scopeParent: a,
          candidates: m
        });
      } else {
        var p = K.call(a, V);
        p && r.filter(a) && (t || !e.includes(a)) && s.push(a);
        var E = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), R = !X(E, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (E && R) {
          var L = o(E === !0 ? a.children : E.children, !0, r);
          r.flatten ? s.push.apply(s, L) : s.push({
            scopeParent: a,
            candidates: L
          });
        } else
          c.unshift.apply(c, a.children);
      }
  }
  return s;
}, ve = function(e) {
  return !isNaN(parseInt(e.getAttribute("tabindex"), 10));
}, M = function(e) {
  if (!e)
    throw new Error("No node provided");
  return e.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || ge(e)) && !ve(e) ? 0 : e.tabIndex;
}, me = function(e, t) {
  var r = M(e);
  return r < 0 && t && !ve(e) ? 0 : r;
}, ye = function(e, t) {
  return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
}, he = function(e) {
  return e.tagName === "INPUT";
}, Te = function(e) {
  return he(e) && e.type === "hidden";
}, we = function(e) {
  var t = e.tagName === "DETAILS" && Array.prototype.slice.apply(e.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return t;
}, Ne = function(e, t) {
  for (var r = 0; r < e.length; r++)
    if (e[r].checked && e[r].form === t)
      return e[r];
}, Ee = function(e) {
  if (!e.name)
    return !0;
  var t = e.form || z(e), r = function(y) {
    return t.querySelectorAll('input[type="radio"][name="' + y + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(e.name));
  else
    try {
      s = r(e.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var c = Ne(s, e.form);
  return !c || c === e;
}, ke = function(e) {
  return he(e) && e.type === "radio";
}, Fe = function(e) {
  return ke(e) && !Ee(e);
}, Se = function(e) {
  var t, r = e && z(e), s = (t = r) === null || t === void 0 ? void 0 : t.host, c = !1;
  if (r && r !== e) {
    var a, y, g;
    for (c = !!((a = s) !== null && a !== void 0 && (y = a.ownerDocument) !== null && y !== void 0 && y.contains(s) || e != null && (g = e.ownerDocument) !== null && g !== void 0 && g.contains(e)); !c && s; ) {
      var m, p, E;
      r = z(s), s = (m = r) === null || m === void 0 ? void 0 : m.host, c = !!((p = s) !== null && p !== void 0 && (E = p.ownerDocument) !== null && E !== void 0 && E.contains(s));
    }
  }
  return c;
}, re = function(e) {
  var t = e.getBoundingClientRect(), r = t.width, s = t.height;
  return r === 0 && s === 0;
}, _e = function(e, t) {
  var r = t.displayCheck, s = t.getShadowRoot;
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  var c = K.call(e, "details>summary:first-of-type"), a = c ? e.parentElement : e;
  if (K.call(a, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var y = e; e; ) {
        var g = e.parentElement, m = z(e);
        if (g && !g.shadowRoot && s(g) === !0)
          return re(e);
        e.assignedSlot ? e = e.assignedSlot : !g && m !== e.ownerDocument ? e = m.host : e = g;
      }
      e = y;
    }
    if (Se(e))
      return !e.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return re(e);
  return !1;
}, Re = function(e) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
    for (var t = e.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var r = 0; r < t.children.length; r++) {
          var s = t.children.item(r);
          if (s.tagName === "LEGEND")
            return K.call(t, "fieldset[disabled] *") ? !0 : !s.contains(e);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, Z = function(e, t) {
  return !(t.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  X(t) || Te(t) || _e(t, e) || // For a details element with a summary, the summary element gets the focus
  we(t) || Re(t));
}, ee = function(e, t) {
  return !(Fe(t) || M(t) < 0 || !Z(e, t));
}, Ce = function(e) {
  var t = parseInt(e.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, Pe = function o(e) {
  var t = [], r = [];
  return e.forEach(function(s, c) {
    var a = !!s.scopeParent, y = a ? s.scopeParent : s, g = me(y, a), m = a ? o(s.candidates) : y;
    g === 0 ? a ? t.push.apply(t, m) : t.push(y) : r.push({
      documentOrder: c,
      tabIndex: g,
      item: s,
      isScope: a,
      content: m
    });
  }), r.sort(ye).reduce(function(s, c) {
    return c.isScope ? s.push.apply(s, c.content) : s.push(c.content), s;
  }, []).concat(t);
}, Oe = function(e, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = de([e], t.includeContainer, {
    filter: ee.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: Ce
  }) : r = ce(e, t.includeContainer, ee.bind(null, t)), Pe(r);
}, De = function(e, t) {
  t = t || {};
  var r;
  return t.getShadowRoot ? r = de([e], t.includeContainer, {
    filter: Z.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : r = ce(e, t.includeContainer, Z.bind(null, t)), r;
}, j = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return K.call(e, V) === !1 ? !1 : ee(t, e);
}, Ae = /* @__PURE__ */ ue.concat("iframe").join(","), Q = function(e, t) {
  if (t = t || {}, !e)
    throw new Error("No node provided");
  return K.call(e, Ae) === !1 ? !1 : Z(t, e);
};
/*!
* focus-trap 7.5.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function ae(o, e) {
  var t = Object.keys(o);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(o);
    e && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(o, s).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ie(o) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ae(Object(t), !0).forEach(function(r) {
      Ie(o, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(t)) : ae(Object(t)).forEach(function(r) {
      Object.defineProperty(o, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return o;
}
function Ie(o, e, t) {
  return e = Le(e), e in o ? Object.defineProperty(o, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : o[e] = t, o;
}
function xe(o, e) {
  if (typeof o != "object" || o === null)
    return o;
  var t = o[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(o, e || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(o);
}
function Le(o) {
  var e = xe(o, "string");
  return typeof e == "symbol" ? e : String(e);
}
var ne = {
  activateTrap: function(e, t) {
    if (e.length > 0) {
      var r = e[e.length - 1];
      r !== t && r.pause();
    }
    var s = e.indexOf(t);
    s === -1 || e.splice(s, 1), e.push(t);
  },
  deactivateTrap: function(e, t) {
    var r = e.indexOf(t);
    r !== -1 && e.splice(r, 1), e.length > 0 && e[e.length - 1].unpause();
  }
}, Be = function(e) {
  return e.tagName && e.tagName.toLowerCase() === "input" && typeof e.select == "function";
}, Me = function(e) {
  return (e == null ? void 0 : e.key) === "Escape" || (e == null ? void 0 : e.key) === "Esc" || (e == null ? void 0 : e.keyCode) === 27;
}, U = function(e) {
  return (e == null ? void 0 : e.key) === "Tab" || (e == null ? void 0 : e.keyCode) === 9;
}, Ke = function(e) {
  return U(e) && !e.shiftKey;
}, je = function(e) {
  return U(e) && e.shiftKey;
}, oe = function(e) {
  return setTimeout(e, 0);
}, se = function(e, t) {
  var r = -1;
  return e.every(function(s, c) {
    return t(s) ? (r = c, !1) : !0;
  }), r;
}, G = function(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
    r[s - 1] = arguments[s];
  return typeof e == "function" ? e.apply(void 0, r) : e;
}, Y = function(e) {
  return e.target.shadowRoot && typeof e.composedPath == "function" ? e.composedPath()[0] : e.target;
}, He = [], Ve = function(e, t) {
  var r = (t == null ? void 0 : t.document) || document, s = (t == null ? void 0 : t.trapStack) || He, c = ie({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: Ke,
    isKeyBackward: je
  }, t), a = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, y, g = function(n, i, f) {
    return n && n[i] !== void 0 ? n[i] : c[f || i];
  }, m = function(n, i) {
    var f = typeof (i == null ? void 0 : i.composedPath) == "function" ? i.composedPath() : void 0;
    return a.containerGroups.findIndex(function(T) {
      var w = T.container, N = T.tabbableNodes;
      return w.contains(n) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      (f == null ? void 0 : f.includes(w)) || N.find(function(k) {
        return k === n;
      });
    });
  }, p = function(n) {
    var i = c[n];
    if (typeof i == "function") {
      for (var f = arguments.length, T = new Array(f > 1 ? f - 1 : 0), w = 1; w < f; w++)
        T[w - 1] = arguments[w];
      i = i.apply(void 0, T);
    }
    if (i === !0 && (i = void 0), !i) {
      if (i === void 0 || i === !1)
        return i;
      throw new Error("`".concat(n, "` was specified but was not a node, or did not return a node"));
    }
    var N = i;
    if (typeof i == "string" && (N = r.querySelector(i), !N))
      throw new Error("`".concat(n, "` as selector refers to no known node"));
    return N;
  }, E = function() {
    var n = p("initialFocus");
    if (n === !1)
      return !1;
    if (n === void 0 || !Q(n, c.tabbableOptions))
      if (m(r.activeElement) >= 0)
        n = r.activeElement;
      else {
        var i = a.tabbableGroups[0], f = i && i.firstTabbableNode;
        n = f || p("fallbackFocus");
      }
    if (!n)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return n;
  }, R = function() {
    if (a.containerGroups = a.containers.map(function(n) {
      var i = Oe(n, c.tabbableOptions), f = De(n, c.tabbableOptions), T = i.length > 0 ? i[0] : void 0, w = i.length > 0 ? i[i.length - 1] : void 0, N = f.find(function(S) {
        return j(S);
      }), k = f.slice().reverse().find(function(S) {
        return j(S);
      }), _ = !!i.find(function(S) {
        return M(S) > 0;
      });
      return {
        container: n,
        tabbableNodes: i,
        focusableNodes: f,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: _,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: T,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: w,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: N,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: k,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(B) {
          var W = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, x = i.indexOf(B);
          return x < 0 ? W ? f.slice(f.indexOf(B) + 1).find(function(q) {
            return j(q);
          }) : f.slice(0, f.indexOf(B)).reverse().find(function(q) {
            return j(q);
          }) : i[x + (W ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(n) {
      return n.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !p("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(n) {
      return n.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, L = function b(n) {
    var i = n.activeElement;
    if (i)
      return i.shadowRoot && i.shadowRoot.activeElement !== null ? b(i.shadowRoot) : i;
  }, A = function b(n) {
    if (n !== !1 && n !== L(document)) {
      if (!n || !n.focus) {
        b(E());
        return;
      }
      n.focus({
        preventScroll: !!c.preventScroll
      }), a.mostRecentlyFocusedNode = n, Be(n) && n.select();
    }
  }, I = function(n) {
    var i = p("setReturnFocus", n);
    return i || (i === !1 ? !1 : n);
  }, H = function(n) {
    var i = n.target, f = n.event, T = n.isBackward, w = T === void 0 ? !1 : T;
    i = i || Y(f), R();
    var N = null;
    if (a.tabbableGroups.length > 0) {
      var k = m(i, f), _ = k >= 0 ? a.containerGroups[k] : void 0;
      if (k < 0)
        w ? N = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : N = a.tabbableGroups[0].firstTabbableNode;
      else if (w) {
        var S = se(a.tabbableGroups, function($) {
          var J = $.firstTabbableNode;
          return i === J;
        });
        if (S < 0 && (_.container === i || Q(i, c.tabbableOptions) && !j(i, c.tabbableOptions) && !_.nextTabbableNode(i, !1)) && (S = k), S >= 0) {
          var B = S === 0 ? a.tabbableGroups.length - 1 : S - 1, W = a.tabbableGroups[B];
          N = M(i) >= 0 ? W.lastTabbableNode : W.lastDomTabbableNode;
        } else
          U(f) || (N = _.nextTabbableNode(i, !1));
      } else {
        var x = se(a.tabbableGroups, function($) {
          var J = $.lastTabbableNode;
          return i === J;
        });
        if (x < 0 && (_.container === i || Q(i, c.tabbableOptions) && !j(i, c.tabbableOptions) && !_.nextTabbableNode(i)) && (x = k), x >= 0) {
          var q = x === a.tabbableGroups.length - 1 ? 0 : x + 1, te = a.tabbableGroups[q];
          N = M(i) >= 0 ? te.firstTabbableNode : te.firstDomTabbableNode;
        } else
          U(f) || (N = _.nextTabbableNode(i));
      }
    } else
      N = p("fallbackFocus");
    return N;
  }, d = function(n) {
    var i = Y(n);
    if (!(m(i, n) >= 0)) {
      if (G(c.clickOutsideDeactivates, n)) {
        y.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: c.returnFocusOnDeactivate
        });
        return;
      }
      G(c.allowOutsideClick, n) || n.preventDefault();
    }
  }, l = function(n) {
    var i = Y(n), f = m(i, n) >= 0;
    if (f || i instanceof Document)
      f && (a.mostRecentlyFocusedNode = i);
    else {
      n.stopImmediatePropagation();
      var T, w = !0;
      if (a.mostRecentlyFocusedNode)
        if (M(a.mostRecentlyFocusedNode) > 0) {
          var N = m(a.mostRecentlyFocusedNode), k = a.containerGroups[N].tabbableNodes;
          if (k.length > 0) {
            var _ = k.findIndex(function(S) {
              return S === a.mostRecentlyFocusedNode;
            });
            _ >= 0 && (c.isKeyForward(a.recentNavEvent) ? _ + 1 < k.length && (T = k[_ + 1], w = !1) : _ - 1 >= 0 && (T = k[_ - 1], w = !1));
          }
        } else
          a.containerGroups.some(function(S) {
            return S.tabbableNodes.some(function(B) {
              return M(B) > 0;
            });
          }) || (w = !1);
      else
        w = !1;
      w && (T = H({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: c.isKeyBackward(a.recentNavEvent)
      })), A(T || a.mostRecentlyFocusedNode || E());
    }
    a.recentNavEvent = void 0;
  }, u = function(n) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = n;
    var f = H({
      event: n,
      isBackward: i
    });
    f && (U(n) && n.preventDefault(), A(f));
  }, v = function(n) {
    if (Me(n) && G(c.escapeDeactivates, n) !== !1) {
      n.preventDefault(), y.deactivate();
      return;
    }
    (c.isKeyForward(n) || c.isKeyBackward(n)) && u(n, c.isKeyBackward(n));
  }, h = function(n) {
    var i = Y(n);
    m(i, n) >= 0 || G(c.clickOutsideDeactivates, n) || G(c.allowOutsideClick, n) || (n.preventDefault(), n.stopImmediatePropagation());
  }, O = function() {
    if (a.active)
      return ne.activateTrap(s, y), a.delayInitialFocusTimer = c.delayInitialFocus ? oe(function() {
        A(E());
      }) : A(E()), r.addEventListener("focusin", l, !0), r.addEventListener("mousedown", d, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", d, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", h, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", v, {
        capture: !0,
        passive: !1
      }), y;
  }, C = function() {
    if (a.active)
      return r.removeEventListener("focusin", l, !0), r.removeEventListener("mousedown", d, !0), r.removeEventListener("touchstart", d, !0), r.removeEventListener("click", h, !0), r.removeEventListener("keydown", v, !0), y;
  }, P = function(n) {
    var i = n.some(function(f) {
      var T = Array.from(f.removedNodes);
      return T.some(function(w) {
        return w === a.mostRecentlyFocusedNode;
      });
    });
    i && A(E());
  }, F = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(P) : void 0, D = function() {
    F && (F.disconnect(), a.active && !a.paused && a.containers.map(function(n) {
      F.observe(n, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return y = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(n) {
      if (a.active)
        return this;
      var i = g(n, "onActivate"), f = g(n, "onPostActivate"), T = g(n, "checkCanFocusTrap");
      T || R(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = r.activeElement, i == null || i();
      var w = function() {
        T && R(), O(), D(), f == null || f();
      };
      return T ? (T(a.containers.concat()).then(w, w), this) : (w(), this);
    },
    deactivate: function(n) {
      if (!a.active)
        return this;
      var i = ie({
        onDeactivate: c.onDeactivate,
        onPostDeactivate: c.onPostDeactivate,
        checkCanReturnFocus: c.checkCanReturnFocus
      }, n);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, C(), a.active = !1, a.paused = !1, D(), ne.deactivateTrap(s, y);
      var f = g(i, "onDeactivate"), T = g(i, "onPostDeactivate"), w = g(i, "checkCanReturnFocus"), N = g(i, "returnFocus", "returnFocusOnDeactivate");
      f == null || f();
      var k = function() {
        oe(function() {
          N && A(I(a.nodeFocusedBeforeActivation)), T == null || T();
        });
      };
      return N && w ? (w(I(a.nodeFocusedBeforeActivation)).then(k, k), this) : (k(), this);
    },
    pause: function(n) {
      if (a.paused || !a.active)
        return this;
      var i = g(n, "onPause"), f = g(n, "onPostPause");
      return a.paused = !0, i == null || i(), C(), D(), f == null || f(), this;
    },
    unpause: function(n) {
      if (!a.paused || !a.active)
        return this;
      var i = g(n, "onUnpause"), f = g(n, "onPostUnpause");
      return a.paused = !1, i == null || i(), R(), O(), D(), f == null || f(), this;
    },
    updateContainerElements: function(n) {
      var i = [].concat(n).filter(Boolean);
      return a.containers = i.map(function(f) {
        return typeof f == "string" ? r.querySelector(f) : f;
      }), a.active && R(), D(), this;
    }
  }, y.updateContainerElements(e), y;
};
export {
  Ye as E,
  qe as S,
  Ge as a,
  Ve as b,
  We as c,
  be as g,
  Ue as q
};
